import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as removeComment from "./removeComment";
import * as retrieveDiscussion from "./retrieveDiscussion";
import * as retrieveDiscussions from "./retrieveDiscussions";
import * as postComment from "./postComment";
import * as startDiscussion from "./startDiscussion";
import * as removeDiscussion from "./removeDiscussion";

const initialState: State = {
  removeComment: removeComment.initialState,
  retrieveDiscussion: retrieveDiscussion.initialState,
  retrieveDiscussions: retrieveDiscussions.initialState,
  postComment: postComment.initialState,
  startDiscussion: startDiscussion.initialState,
  removeDiscussion: removeDiscussion.initialState,
};

const reduceState = combineStateReducer(initialState, {
  removeComment: removeComment.reduceState,
  retrieveDiscussion: retrieveDiscussion.reduceState,
  retrieveDiscussions: retrieveDiscussions.reduceState,
  postComment: postComment.reduceState,
  startDiscussion: startDiscussion.reduceState,
  removeDiscussion: removeDiscussion.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...removeComment.createSelector(() => getState().removeComment),
    ...retrieveDiscussion.createSelector(() => getState().retrieveDiscussion),
    ...retrieveDiscussions.createSelector(() => getState().retrieveDiscussions),
    ...postComment.createSelector(() => getState().postComment),
    ...startDiscussion.createSelector(() => getState().startDiscussion),
    ...removeDiscussion.createSelector(() => getState().removeDiscussion),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
